import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `
  <h2>Middle School Programme</h2>
  <p><em>Evolving the perspective and experience palette</em></p>
  <p>The formative years of education are Middle School, where either you fall in love with learning or you do not. As educators, it is crucial to design the curriculum in a way that makes learning fun and interesting.</p>
  <p>At St. Andrews World School, the Middle School Programmes inculcate a positive attitude toward learning. We aim to create the right balance between concepts and experiences for effective learning. The curriculum is interdisciplinary where the content and skills are interwoven through each subject. Our focus is to deliver a combined approach that is beyond the mundane subject curricula and involves experiences that compel the students to get completely involved in the subject.</p>
  <p>We help the students build disciplinary habits of proper planning and execution. The curriculum crafted involves community engagement through real-life projects and community service. The handed projects are experiential-based where the students have to observe, analyze, reflect, and understand the concept. We help them to evolve their voices and perspectives towards not just academics but also the community. Empowering the students to think about social, cultural, or ecological issues leads them to be motivated toward bringing societal change.</p>
  <p>We bring the subject expertise to the class and build engaging learning experiences while equally involving practical on-field experiences. The Middle School Programme helps the students achieve academic excellence and personality development.</p>
`;

const MiddleSchoolProgrammePage = () => {
  const pageData = usePage('middle-school-programme', { content: DEFAULT_CONTENT });

  const title = 'Middle School Programme';

  return (
    <>
      <SEO title={title} description="Middle School Programme at St. Andrews World School, Siddharth Vihar. Evolving the perspective and experience palette." keywords="Middle School Programme, SAWS Siddharth Vihar" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || `${process.env.PUBLIC_URL}/images/page-banners/admission-guidliness.jpg`} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner"></div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed space-y-5" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default MiddleSchoolProgrammePage;
